import { Directive, Output, EventEmitter, HostListener, HostBinding } from '@angular/core';

@Directive({
  selector: '[appDragDrop]'
})
export class DragDropDirective {

  @Output() dropEvent = new EventEmitter<any>();

  @HostBinding('style.border') private border;
  @HostBinding('style.padding') private padding;

  @HostListener('dragover', ['$event']) onDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    this.border = 'solid 1px #1e88e5';
    this.padding = '1rem';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    this.border = 'dashed 1px lightgrey';
    this.padding = '3rem';
  }

  @HostListener('drop', ['$event']) public ondrop(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dropEvent.emit(e);
    this.border = 'dashed 1px lightgrey';
    this.padding = '3rem';
  }

}
